<template>
  <v-navigation-drawer ref="leftNavPanel" app clipped v-if="isLogined && navigation && isNavVisible" v-show="isNavVisible" :value="value"
    @input="navModelOnChange" id="app-left-nav" :permanent="permanent" hide-overlay :expand-on-hover="miniVariant"
    :class="miniVariant ? 'mini-variant' : ''" :mini-variant="miniVariant">

    <v-layout column fill-height justify-space-between>

      <v-flex v-if="!permanent" shrink>
        <v-toolbar dense flat color="app-colors-background-light">
          <v-toolbar-title>{{$t('navigation.menu')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="$emit('input', false)">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
      </v-flex>

      <dx-scroll-view>
        <v-flex class="main-modules">
          <left-nav-list :listItems="mainModules"></left-nav-list>
        </v-flex>
        <v-flex v-if="additionalModules.length" class="additional-modules py-2">
          <left-nav-list :listItems="additionalModules"></left-nav-list>
        </v-flex>
      </dx-scroll-view>

      <v-flex shrink class="pa-2 font-weight-medium app-version-container text-body-2">
        <span v-show="offlineModeShowName" class="pa-1">
          <div>
            <span v-if="miniVariant" class="offline-mode-name" v-html="offlineModeSmallName"></span>
            <span v-else class="offline-mode-name" v-html="offlineModeLongName"></span>
          </div>
        </span>
        <span v-show="diskUsageShow" class="disk-usage pa-1" @click="showTariffPage">
          <app-tooltip>
            <div>
              <span :class="diskUsageClass" v-html="currentSize"></span>
              <span> {{$t('common.from')}}&nbsp;</span>
              <span v-html="maxSize"></span>
            </div>
            <template v-slot:tooltip> {{$t('common.spacetooltip')}}</template>
          </app-tooltip>
        </span>
        <span  class="disk-usage pa-1" v-show="deliveryUsageShow">
          <app-tooltip color="white" right nudge-left="50" nudge-top="40" :close-delay="1500" content-class="documentTooltip">
            <div v-if="miniVariant">
              <span class="delivery-add">{{availableDeliveriesTotal}}</span>
            </div>
            <div v-else>
              <span @click="showTariffPage">
                {{$t('common.deliverytooltip.totalDelivery')}}&nbsp;<span class="delivery-add">{{availableDeliveriesTotal}}</span>
              </span>
            </div>
            <template v-slot:tooltip>
                <v-col>
                  <v-row justify="space-between">
                    <span><b>{{$t('common.deliverytooltip.totalDelivery')}}</b></span>
                    <span class="payedDocs">{{availableDeliveriesTotal}}</span>
                  </v-row>
                  <v-row justify="space-between">
                    <span>{{$t('common.deliverytooltip.paid')}}</span>
                    <span class="payedDocs">{{availableAdditionalDeliveries}}</span>
                  </v-row>
                  <v-row justify="space-between">
                    <span>{{$t('common.deliverytooltip.free')}}</span>
                    <span class="freeDocs">{{availableTariffPlanDeliveries}}</span>
                  </v-row>
                  <v-row justify="center">
                    <span @click="showTariffPage">
                      <a class="tariffLink">{{$t('common.deliverytooltip.replenishBalance')}}</a>
                    </span>
                  </v-row>
                </v-col>
            </template>
          </app-tooltip>
        </span>
        <div v-if="miniVariant">
          v <span class="version-info" @click="showNewsPage">
              <app-tooltip top>
                <a>{{curentVersion}}</a>
                <template v-slot:tooltip> {{ $t('navigation.hint.version') }} </template>
              </app-tooltip>
            </span>
        </div>
        <div v-else>
          &copy;{{prodYear}}&nbsp;<strong>InfoPlus</strong>&nbsp;&nbsp;
          <span class="version-info" @click="showNewsPage">
            <app-tooltip top>
              <span>(v.</span>
              <a>{{curentVersion}}</a>
              <span>)</span>
              <template v-slot:tooltip> {{ $t('navigation.hint.version') }} </template>
            </app-tooltip>
          </span>
        </div>
      </v-flex>

    </v-layout>

  </v-navigation-drawer>
</template>

<script>
import get from 'lodash/get';

import AppTooltip from '@/components/Common/AppTooltip';
import LeftNavList from '@/components/Main/LeftNavList';

import { Navigations } from '@/models/navigation.core';
import { actions as _act } from '@/models/store.actions';

import { DxScrollView } from 'devextreme-vue/scroll-view';
import { RouterView } from '@/models/enums';

export default {
  name: 'LeftNavPanel',
  components: { LeftNavList, AppTooltip, DxScrollView },
  props: {
    miniVariant: { default: false },
    value: { default: false },
    permanent: { default: true }
  },
  data: function() {
    return {
      navigation: undefined,
      skipNextEmitOnNavModelChanged: true
    };
  },
  inject: ['isMobile', 'isMobileOnly'],
  computed: {
    prodYear() {
      return this.appSettings.year || '2019';
    },
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    balance() {
      return this.$store.getters[_act.DOC_GET_BALANCE];
    },
    availableAdditionalDeliveries() {
      return (this.balance ? this.balance.deliveryAdd : 0) || 0;
    },
    availableTariffPlanDeliveries() {
      return (this.balance ? (this.balance.deliveryFreeCur + this.balance.deliveryCredit) : 0) || 0;
    },
    availableDeliveriesTotal() {
      return this.availableAdditionalDeliveries + this.availableTariffPlanDeliveries;
    },
    currentSize() {
      if (this.balance) {
        return (this.balance.spaceExist / 1024 / 1024).toFixed(2) + '&nbsp;MB';
      } else {
        return '';
      }
    },
    maxSize() {
      if (this.balance) {
        return this.balance.spaceMax / 1024 / 1024 + '&nbsp;MB';
      } else {
        return '';
      }
    },
    offlineModeSmallName() {
      return get(this, 'appSettings.globalSettings.globalSettingItems.sysnameshort.settingValue');
    },
    offlineModeLongName() {
      return get(this, 'appSettings.globalSettings.globalSettingItems.sysnamelong.settingValue');
    },
    offlineModeShowName() {
      return !this.isMonetizationEnabled;
    },
    deliveryUsageShow() {
      return this.isMonetizationEnabled;
    },
    diskUsageShow() {
      return this.isMonetizationEnabled && (this.balance.spaceExist / this.balance.spaceMax) * 100 > 70;
    },
    diskUsageClass() {
      if (this.balance) {
        let persent = (this.balance.spaceExist / this.balance.spaceMax) * 100;
        if (persent <= 50) {
          return 'disk-usage-low';
        } else if (persent > 50 && persent <= 90) {
          return 'disk-usage-half';
        } else {
          return 'disk-usage-overflow';
        }
      } else {
        return '';
      }
    },
    additionalModules() {
      return this.navigation.additionalModules;
    },
    curentVersion() {
      return this.$store.getters[_act.SETT_GET_CURENTVERSIONGET];
    },
    isLogined() {
      return this.$store.getters[_act.AUTH_GET_ISLOGINEDGET];
    },
    isNavVisible() {
      return ![
        RouterView.Login,
        RouterView.Registration,
        RouterView.RegistrationCompletion,
        RouterView.RestorePass,
        RouterView.ConfirmEmail,
        RouterView.RegistrationConfirm,
        RouterView.RestorePassConfirm,
        RouterView.AccountRestore,
        RouterView.ConfirmRestoreAccount,
        RouterView.ConfirmRemoveAccount,
        RouterView.ConfirmEmailUserOrg,
        RouterView.RoumingReg,
        RouterView.RoumingLogin
      ].includes(this.$route.name);
    },
    mainModules() {
      return this.navigation.mainModules;
    },
    testServerName() {
      return this.appSettings ? this.appSettings.testServerName : '';
    },
    allowViewTariffs() {
      return this.$store.getters[_act.AUTH_GET_ACTIONSGET].includes(10900);
    },
    workMode() {
      let workMode = +(get(this, 'appSettings.globalSettings.globalSettingItems.workmode.settingValue') || '0');
      return workMode;
    },
    isMonetizationEnabled() {
      return this.workMode === 0;
    }
  },
  mounted() {
    if (this.isLogined) {
      this.navigation = new Navigations();
    }
    this.$eventBus.$on('user-logged', this.userLoggedMessageHandler);
    this.$eventBus.$on('folders-changed', () => {
      this.navigation.updateFolders();
    });
    this.$eventBus.$on('rebuild-navigation', () => {
      this.navigation = new Navigations();
    });
    if (!this.permanent) {
      this.$eventBus.$on('close-left-nav-panel', () => this.$emit('input', false));
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('user-logged', this.userLoggedMessageHandler);
    this.$eventBus.$off('folders-changed');
    this.$eventBus.$off('rebuild-navigation');
    this.$eventBus.$off('close-left-nav-panel');
  },
  methods: {
    navModelOnChange(val) {
      if (this.permanent) {
        if (!val) {
          this.$refs.leftNavPanel.isActive = true;
        }
        if (!this.skipNextEmitOnNavModelChanged) {
          this.$emit('onMiniVariantChanged', !val);
        }
        this.skipNextEmitOnNavModelChanged = !this.skipNextEmitOnNavModelChanged;
      } else {
        this.$emit('input', val);
      }
    },
    showTariffPage() {
      if (this.allowViewTariffs && this.$route.path !== '/cabinet/tariffs') {
        this.$router.push('/cabinet/tariffs');
      }
    },
    showNewsPage() {
      if (this.$route.path !== '/news') {
        this.$router.push('/news');
      }
    },
    userLoggedMessageHandler() {
      this.navigation = new Navigations();
    }
  }
};
</script>

<style lang="scss">
#app-left-nav {
  .v-list-item__action {
    min-width: 36px;
    margin: 0;
  }
  .v-list-item__icon.v-list-group__header__append-icon {
    margin-left: 0;
    max-width: 24px;
  }
  .additional-modules {
    border-top: 1px solid var(--v-app-colors-border-light-base);
    min-height: 100px;
  }
  .app-version-container {
    border-top: 1px solid var(--v-app-colors-border-light-base);
    text-align: center;
  }
  .disk-usage {
    cursor: pointer;
    font-size: 1.1em;
    text-align: center;
  }
  .version-info {
    cursor: pointer;
    a:hover {
      text-decoration: underline;
    }
  }
  .disk-usage:hover {
    text-decoration: underline;
    color: var(--v-app-colors-link-base);
  }
  .disk-usage-overflow {
    color: var(--v-error-base);
  }
  .disk-usage-low {
    color: var(--v-primary-base);
  }
  .disk-usage-half {
    color: var(--v-warning-base);
  }
  .delivery-add {
    color: var(--v-primary-base);
  }
  .delivery-free {
    color: var(--v-accent-base);
  }
  .delivery-divider {
    margin-right: 5px;
    margin-left: 5px;
    font-weight: 700;
  }
  .offline-mode-name {
    color: var(--v-primary-base);
    font-size: 1.1em;
    font-weight: 700;
  }
}
.documentTooltip{
  pointer-events: initial;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15);
  width: 244px;
  &::before{
    content:'';
    display:block;
    width:3px;
    height:100%;
    background-color: var(--v-primary-base);
    position: absolute;
    top:0;
    left: 0;
  }
  span{
    font-weight:600;
    font-size: 15px;
    line-height: 26px;
    color: var(--v-app-colors-text-base);
  }
  .freeDocs{
    color: var(--v-accent-base);
  }
  .payedDocs {
    color: var(--v-primary-base);
  }
  .tariffLink {
    cursor: pointer;
    text-decoration: underline;
    color: var(--v-secondary-base);
  }
}
</style>
